import React from 'react';
import { motion } from 'framer-motion';
import { assets } from '../lib/assets';

const points = [
  { title: 'Real land', copy: '18 acres of private family orchard in Kalwan Taluka, near Nashik.' },
  { title: 'Real trees', copy: 'Native fruit saplings — hand-picked, named, rooted in living soil.' },
  { title: 'Real farmers', copy: 'Tended year-round by Ganesh-kaka and his team — watering, pruning, caring.' },
];

export default function About() {
  return (
    <section id="about" className="bg-brand-bg py-28 md:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="lg:col-span-6"
        >
          <p className="text-brand-gold tracking-[0.25em] uppercase text-xs mb-5 font-medium">About Pallavit</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1.05] tracking-tight font-light">
            A gift that <em className="text-brand-forest">puts down roots.</em>
          </h2>
          <p className="mt-6 text-brand-ink2 text-lg leading-relaxed max-w-xl">
            Pallavit lets you adopt and dedicate a real fruit tree in the name of someone you love.
            It grows in our family orchard, watched over by farmers who know it by your dedication.
          </p>
          <p className="mt-4 text-brand-ink2 text-lg leading-relaxed max-w-xl">
            You visit. You see it grow. You taste the fruit. A few decades from now, it will still
            be there — carrying their name through every season.
          </p>

          <div className="mt-10 space-y-5">
            {points.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, x: -12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                className="flex items-start gap-4"
                data-testid={`about-point-${i}`}
              >
                <div className="mt-1 w-8 h-8 rounded-full bg-brand-forest/10 border border-brand-forest/20 flex items-center justify-center text-brand-forest font-serif">
                  {i + 1}
                </div>
                <div>
                  <div className="font-serif text-xl text-brand-ink">{p.title}</div>
                  <div className="text-brand-ink2 text-[15px] leading-relaxed">{p.copy}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="lg:col-span-6"
        >
          <div className="relative grid grid-cols-6 grid-rows-6 gap-3 h-[520px]">
            <div className="col-span-4 row-span-4 rounded-3xl overflow-hidden">
              <img src={assets.hero} alt="Orchard near Nashik" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-2 row-span-3 rounded-3xl overflow-hidden">
              <img src={assets.plaque} alt="Name plaque on tree" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-2 row-span-3 rounded-3xl overflow-hidden">
              <img src={assets.treePlanting} alt="Planting a sapling" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-4 row-span-2 rounded-3xl overflow-hidden">
              <img src={assets.fruitBasket} alt="Fruit harvest" className="w-full h-full object-cover" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
